import React from "react";
import StyledTextInputField from "../../../../../../../../GlobalComponents/InputField/StyledTextInputField/StyledTextInputField";
import SelectField from "../../../../../../../../GlobalComponents/InputField/SelectField/SelectField";

function TaxNumber({
  countryOfFormation,
  idType,
  setIDType,
  idTypeError,
  setIDTypeError,
  idNumber,
  setIDNumber,
  idNumberError,
  setIDNumberError,
}) {
  const idTypeOptions = [
    { value: "EIN", label: "EIN" },
    { value: "FTID", label: "Foreign Tax ID" },
    { value: "ITIN", label: "ITIN" },
  ];
  return (
    <React.Fragment>
      <div className="row g-0 w-100 mb-4">
        {countryOfFormation !== "United States" && (
          <div className="col pe-2">
            <SelectField
              value={idType}
              setValue={setIDType}
              valueError={idTypeError}
              setValueError={setIDTypeError}
              label={"Tax ID Type"}
              required={true}
              fullWidth={true}
              size={"small"}
              disabled={true}
              shrink={true}
              id={"entity-account-details-id-type-select"}
              selectOptions={idTypeOptions}
            />
          </div>
        )}
        <div
          className={
            countryOfFormation === "United States"
              ? "col pe-0"
              : "col pe-0 ps-2"
          }
        >
          {countryOfFormation === "United States" && (
            <StyledTextInputField
              value={idNumber}
              setValue={setIDNumber}
              valueError={idNumberError}
              setValueError={setIDNumberError}
              label={"EIN"}
              required={true}
              fullWidth={true}
              size={"small"}
              disabled={true}
              shrink={true}
              id={"entity-account-details-ein-input"}
            />
          )}
          {countryOfFormation !== "United States" && (
            <StyledTextInputField
              value={idNumber}
              setValue={setIDNumber}
              valueError={idNumberError}
              setValueError={setIDNumberError}
              label={"Tax ID Number"}
              required={true}
              fullWidth={true}
              size={"small"}
              disabled={true}
              shrink={true}
              id={"entity-account-details-tax-id-input"}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
export default TaxNumber;
